import { render, staticRenderFns } from "./zmlawtj.vue?vue&type=template&id=c4ca94d2&scoped=true&"
import script from "./zmlawtj.vue?vue&type=script&lang=js&"
export * from "./zmlawtj.vue?vue&type=script&lang=js&"
import style0 from "./zmlawtj.vue?vue&type=style&index=0&id=c4ca94d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ca94d2",
  null
  
)

export default component.exports